var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"py-5 bg-dark"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"m-0 text-center text-white"},[_vm._v(" Servicio Electoral "+_vm._s(_vm.version)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }